import { useSnackbar } from "notistack"
import { useContext } from "react"
import { useQuery } from "react-query"
import AuthContext from "../Context/auth_provider.jsx"
import useAxiosPrivate from "./useAxiosPrivate.js"

// Fetch/Get All Entities List Per-Page, with Filter, Search and Sort Preferences Hook
const useFetchEntitiesPerPage = (props, options) => {
    const axiosPrivate = useAxiosPrivate()
    const { companyId, teamId } = useContext(AuthContext)
    const domain = teamId ? `/team/${teamId}` : `/corporate/${companyId}`
    const { endPoint, page, perPage, filterModel, sortModel, searchText } =
        props

    const { enqueueSnackbar } = useSnackbar()

    return useQuery({
        queryKey: [
            endPoint,
            page,
            perPage,
            filterModel,
            sortModel?.length,
            filterModel?.length,
            sortModel,
            undefined,
            searchText,
            domain],
        queryFn: () =>
            axiosPrivate
                .get(`${domain}/${endPoint}`, {
                    params: {
                        page: page,
                        per_page: perPage,
                        sort:
                            sortModel?.length === 0
                                ? undefined
                                : JSON.stringify(sortModel),
                        search: searchText,
                        filter:
                            filterModel?.length === 0
                                ? []
                                : JSON.stringify(filterModel),
                        link_operator: "and",
                    },
                })
                .then((response) => response),

        onError: (error) => {
            const fieldError =
                error.response?.data?.error?.field_error?.[0]?.description
            const errorMessage = error.response?.data?.error?.message
            enqueueSnackbar(fieldError || errorMessage || "Request Failed", {
                variant: "error",
            })
        },
        ...options,
    })
}

export default useFetchEntitiesPerPage
